import { render, staticRenderFns } from "./ReturnView.vue?vue&type=template&id=c02d21e4&scoped=true&"
import script from "./ReturnView.vue?vue&type=script&lang=js&"
export * from "./ReturnView.vue?vue&type=script&lang=js&"
import style0 from "./ReturnView.vue?vue&type=style&index=0&id=c02d21e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c02d21e4",
  null
  
)

export default component.exports